<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-tab-footer">
            <el-form
              class="box"
              ref="productForm"
              :model="product"
              label-width="70px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">{{
                      product.productNo
                    }}</el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">{{
                      product.categoryName
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.unit')">{{
                      product.unit
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.brand')">{{
                      product.brand
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('product.purchaseUrl')"
                      :prop="'purchaseUrl'"
                    >
                      <a
                        v-if="
                          product.purchaseUrl != null &&
                          product.purchaseUrl.trim() != ''
                        "
                        :href="product.purchaseUrl"
                        target="_blank"
                        >链接</a
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('product.mainMaterial')"
                      :prop="'mainMaterial'"
                    >
                      {{ product.mainMaterial }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                    <el-form-item :label="$t('product.salesPrice')"
                      ><currency
                        :code="product.salesCurrency"
                        v-if="product.salesPrice != null"
                      ></currency
                      >{{ product.salesPrice }}</el-form-item
                    >
                  </el-col>
                  <el-col v-if="Permit.canActions('globalCostPrice')" :span="8">
                    <el-form-item :label="$t('product.costPrice')"
                      >{{ product.costPrice | currency }}
                      <el-button
                        v-if="
                          Permit.canActions('productManage') &&
                          Permit.extendModels().includes('mes')
                        "
                        type="text"
                        size="mini"
                        @click="synMes"
                        >{{ $t("action.synMes") }}</el-button
                      >
                    </el-form-item>
                  </el-col>
                  <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                    <el-form-item :label="$t('product.wholeSalePrice')">{{
                      product.wholesalePrice | currency
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    v-if="
                      Permit.extendModels().includes('mms') &&
                      Permit.canActions('globalCostPrice')
                    "
                    :span="8"
                  >
                    <el-form-item :label="$t('material.baseCost')">
                      {{ mmsCost | currency }}
                    </el-form-item>
                  </el-col>
                  <el-col
                    v-if="
                      Permit.extendModels().includes('mes') &&
                      Permit.canActions('globalCostPrice') &&
                      mesCost.length != 0
                    "
                    :span="16"
                  >
                    <el-form-item :label="$t('phase.baseCost')">
                      <span
                        v-for="(mesc, index) of mesCost"
                        :key="index"
                        class="mgr10 font10"
                      >
                        {{ mesc.factoryName }}:{{ mesc.cost | currency }}
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="8"
                    v-if="
                      Permit.extendModels().includes('mes') &&
                      Permit.currentTenant().config.mesSchedule == true
                    "
                  >
                    <el-form-item
                      :label="$t('product.mesCycle')"
                      :prop="'mesCycle'"
                    >
                      {{ product.mesCycle }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('product.productNoAlias')"
                      :prop="'productNos'"
                    >
                      <span
                        v-for="(item, itemIndex) of product.productNos"
                        :key="itemIndex"
                        class="mgr10"
                      >
                        <span v-if="item.error" class="red"
                          >{{ item.productNo }}<small>(重复)</small></span
                        >
                        <span v-else>{{ item.productNo }}</span>
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15" v-if="product && product.productHsInfo">
                <legend>{{ $t("product.productHsInfo") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.hsCode')"
                      :prop="'productHsInfo.hsCode'"
                    >
                      {{ product.productHsInfo.hsCode }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.goodsName')"
                      :prop="'productHsInfo.goodsName'"
                    >
                      {{ product.productHsInfo.goodsName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.goodsNameEn')"
                      :prop="'productHsInfo.goodsNameEn'"
                    >
                      {{ product.productHsInfo.goodsNameEn }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.weight')"
                      :prop="'productHsInfo.weight'"
                    >
                      {{ product.productHsInfo.weight }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.firstUnit')"
                      :prop="'productHsInfo.firstUnit'"
                      label-width="100px"
                    >
                      {{ product.productHsInfo.firstUnit }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.secondUnit')"
                      :prop="'productHsInfo.secondUnit'"
                      label-width="100px"
                    >
                      {{ product.productHsInfo.secondUnit }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.declareInfo')"
                      :prop="'productHsInfo.declareInfo'"
                    >
                      {{ product.productHsInfo.declareInfo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('category.insured')"
                      :prop="'productHsInfo.insured'"
                    >
                      {{ product.productHsInfo.insured }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <el-row :gutter="10">
                <el-col :span="14">
                  <fieldset
                    v-if="
                      product.productLabels && product.productLabels.length != 0
                    "
                    class="mgb15"
                  >
                    <legend>{{ $t("product.label") }}</legend>
                    <el-tag
                      v-for="productLabel in product.productLabels"
                      :key="productLabel.name"
                      type="info"
                      >{{ productLabel.name }}</el-tag
                    >
                  </fieldset>
                  <fieldset
                    v-if="product.colors && product.colors.length != 0"
                    class="mgb15"
                  >
                    <legend>{{ $t("product.color") }}</legend>
                    <el-tag
                      v-for="color in product.colors"
                      :key="color"
                      type="info"
                      >{{ color }}</el-tag
                    >
                  </fieldset>
                  <fieldset
                    v-if="product.sizes && product.sizes.length != 0"
                    class="mgb15"
                  >
                    <legend>{{ $t("product.size") }}</legend>
                    <el-tag
                      v-for="size in product.sizes"
                      :key="size"
                      type="info"
                      >{{ size }}</el-tag
                    >
                  </fieldset>
                  <fieldset
                    v-if="
                      product.customAttributeJson != null &&
                      product.customAttributeJson != '[]'
                    "
                    class="mgb15"
                  >
                    <legend>{{ $t("menu.attributes") }}</legend>
                    <el-tag
                      v-for="customAttribute in JSON.parse(
                        product.customAttributeJson
                      )"
                      :key="customAttribute"
                      type="info"
                      >{{ customAttribute }}</el-tag
                    >
                  </fieldset>
                  <fieldset v-if="product.introduction != null" class="mgb15">
                    <legend>{{ $t("product.introduction") }}</legend>
                    <raw-html :content="product.introduction" />
                  </fieldset>
                  <fieldset class="mgb15">
                    <legend>
                      {{ $t("product.craftwork") }}
                      <el-button
                        v-if="Permit.canActions('productManageCraftwork')"
                        type="primary"
                        size="mini"
                        @click="updataCraftwork(row)"
                        >{{ $t("text.edit") }}</el-button
                      >
                    </legend>
                    <raw-html :content="product.craftwork" type="richText" />
                  </fieldset>
                </el-col>
                <el-col :span="10">
                  <fieldset v-if="product.images != null" class="mgb15">
                    <legend>{{ $t("product.images") }}</legend>
                    <thumbnail
                      :images="product.images"
                      :list="true"
                      width="50"
                      height="auto"
                    />
                  </fieldset>
                  <fieldset
                    v-if="
                      product.productSizePrices &&
                      product.productSizePrices.length != 0 &&
                      (Permit.canActions('globalSalePrice') ||
                        Permit.canActions('globalCostPrice'))
                    "
                    class="mgb15"
                  >
                    <legend>{{ $t("product.sizePrice") }}</legend>
                    <vxe-table
                      :data="product.productSizePrices"
                      id="priceTable"
                      row-id="id"
                      ref="recordsTable"
                      class="recordsTable"
                      size="mini"
                      resizable
                      round
                      highlight-hover-row
                      auto-resize
                      border
                      :scroll-y="{ enabled: false }"
                    >
                      <vxe-table-column
                        field="size"
                        :title="$t('product.size')"
                      />
                      <vxe-table-column
                        v-if="Permit.canActions('globalSalePrice')"
                        field="salesPrice"
                        :title="$t('product.salesPrice')"
                      >
                        <template v-slot="{ row }">
                          <currency
                            :code="product.salesCurrency"
                            v-if="product.salesPrice != null"
                          ></currency
                          >{{ row.salesPrice }}</template
                        >
                      </vxe-table-column>
                      <vxe-table-column
                        v-if="Permit.canActions('globalCostPrice')"
                        field="costPrice"
                        :title="$t('product.costPrice')"
                      >
                        <template v-slot="{ row }">{{
                          row.costPrice | currency
                        }}</template>
                      </vxe-table-column>
                      <vxe-table-column
                        v-if="Permit.canActions('globalSalePrice')"
                        field="wholesalePrice"
                        :title="$t('product.wholeSalePrice')"
                      >
                        <template v-slot="{ row }">{{
                          row.wholesalePrice | currency
                        }}</template>
                      </vxe-table-column>
                    </vxe-table>
                  </fieldset>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('menu.phases')"
          name="phase"
          v-if="
            Permit.extendModels().includes('mes') &&
            (Permit.canActionsChargeEdition('mesProductView') ||
              Permit.canActionsChargeEdition('globalCostPrice'))
          "
        >
          <show-phase :uuid="uuid" :showBaseInfoDF="false" />
        </el-tab-pane>
        <el-tab-pane
          :label="$t('menu.materials')"
          name="material"
          v-if="
            Permit.extendModels().includes('mms') &&
            (Permit.canActionsChargeEdition('mmsProductView') ||
              Permit.canActionsChargeEdition('globalCostPrice'))
          "
        >
          <show-material :uuid="uuid" :showBaseInfoDF="false" />
        </el-tab-pane>
        <el-tab-pane :label="$t('menu.suppliers')" name="supplier">
          <div class="drawer-content with-tab-footer">
            <fieldset v-if="Permit.canActions('globalSupplier')" class="mgb15">
              <vxe-table
                :data="productSuppliers"
                id="productSuppliersTable"
                row-id="id"
                ref="recordsTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                highlight-hover-row
                auto-resize
                border
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="supplierName"
                  :title="$t('menu.suppliers')"
                />
                <vxe-table-column
                  v-if="Permit.canActions('globalPurchasePrice')"
                  field="price"
                  :title="$t('product.supplierPrice')"
                >
                  <template v-slot="{ row }">{{
                    row.price | currency
                  }}</template>
                </vxe-table-column>

                <vxe-table-column
                  v-if="Permit.canActions('globalPurchasePrice')"
                  field="supplierSizePrices"
                  :title="$t('product.supplierSizePrice')"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.supplierSizePrices.length != 0">
                      <div
                        v-for="supplierSizePrice of row.supplierSizePrices"
                        :key="supplierSizePrice.id"
                        class="font10"
                      >
                        {{ supplierSizePrice.size }}:{{
                          supplierSizePrice.price | currency
                        }}
                      </div>
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="productNo"
                  :title="$t('product.supplierProductNo')"
                />
                <vxe-table-column
                  field="defaultSupplier"
                  :title="$t('product.defaultSupplier')"
                  width="90"
                >
                  <template v-slot="{ row }">{{
                    $t("boolean." + row.defaultSupplier)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="action"
                  :title="$t('text.action')"
                  width="180"
                >
                  <template v-slot="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="editProductSupplier(row)"
                      >{{ $t("text.edit") }}</el-button
                    >
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteProductSupplier(row)"
                      >{{ $t("text.delete") }}</el-button
                    >
                    <el-button
                      v-if="!row.defaultSupplier"
                      type="text"
                      size="mini"
                      @click="setDefaultSupplier(row)"
                      >{{ $t("action.setDefaultSupplier") }}</el-button
                    >
                    <div>
                      <el-button
                        type="text"
                        size="mini"
                        @click="synSupplierPrice(row)"
                        >{{ $t("action.synSupplierPrice") }}</el-button
                      >
                    </div>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('action.share')" name="quotation">
          <div class="drawer-content with-tab-footer">
            <fieldset
              v-if="Permit.canActionsChargeEdition('quoteToCustomerView')"
              class="mgb15"
            >
              <div class="mgb10">
                <el-input
                  v-model.trim="quotationSearchCustomName"
                  :placeholder="$t('rules.required', [$t('menu.customers')])"
                  style="width: 250px"
                  class="mgl5"
                  clearable
                  size="mini"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="searchProductQuotation"
                  />
                </el-input>
              </div>
              <vxe-table
                :data="productQuotationsSearch"
                id="productQuotationsTable"
                row-id="id"
                ref="recordsTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                highlight-hover-row
                auto-resize
                border
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="customerName"
                  :title="$t('menu.customers')"
                >
                  <template v-slot="{ row }">
                    {{ row.customerName }}
                    <span v-if="row.inquirierName != null" class="font10"
                      >({{ row.inquirierName }})</span
                    >
                  </template>
                </vxe-table-column>
                <vxe-table-column field="price" :title="$t('quotation.price')">
                  <template v-slot="{ row }">{{
                    row.price | currency
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="quotationSizePrices"
                  :title="$t('quotation.sizePrice')"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.quotationSizePrices.length != 0">
                      <div
                        v-for="quotationSizePrice of row.quotationSizePrices"
                        :key="quotationSizePrice.id"
                        class="font10"
                      >
                        {{ quotationSizePrice.size }}:{{
                          quotationSizePrice.price | currency
                        }}
                      </div>
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="createAt"
                  :title="$t('quotation.createAt')"
                  width="110"
                />
                <vxe-table-column
                  v-if="Permit.extendModels().includes('wms')"
                  field="hasInv"
                  :title="$t('quotation.hasInv')"
                  width="80"
                >
                  <template v-slot="{ row }">{{
                    $t("boolean." + row.hasInv)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="action"
                  :title="$t('text.action')"
                  width="90"
                >
                  <template v-slot="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="editProductQuotation(row)"
                      >{{ $t("text.edit") }}</el-button
                    >
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteProductQuotation(row)"
                      >{{ $t("text.delete") }}</el-button
                    >
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('product.sizeTemplates')" name="sizeTemplate">
          <div class="drawer-content with-tab-footer">
            <fieldset class="mgb15">
              <vxe-table
                :data="productSizeTemplates"
                id="productSizeTemplatesTable"
                row-id="id"
                ref="recordsTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                highlight-hover-row
                auto-resize
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="size"
                  :title="$t('product.size')"
                  min-width="100"
                />
                <vxe-table-column
                  field="sizeExplain"
                  :title="$t('product.sizeExplain')"
                  min-width="140"
                >
                  <template v-slot="{ row }">
                    <raw-html-limit-number
                      :content="row.sizeExplain"
                      :number="6"
                    />
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="template"
                  :title="$t('product.productSizeTemplate')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <a
                      v-if="row.template"
                      class="blue font10"
                      :href="row.template"
                      target="_blank"
                      >{{ $t("action.download") }}</a
                    >
                    {{ row.fileName }}
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  v-if="Permit.canActions('productManage')"
                  field="action"
                  :title="$t('text.action')"
                  width="50"
                >
                  <template v-slot="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteProductSizeTemplate(row)"
                      >{{ $t("text.delete") }}</el-button
                    >
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('product.lifeCycle')" name="lifeCycle">
          <div class="drawer-content with-tab">
            <div v-if="Permit.extendModels().includes('oms')">
              <panel title="销量月份折线图" class="mgb10">
                <div v-if="orderProductLifeCycle == true">
                  <i class="el-icon-loading"></i>
                </div>
                <ve-line
                  :data="orderTheadData"
                  v-if="
                    orderProductLifeCycle == false &&
                    orderTheadData.rows.length != 0
                  "
                  :extend="extend"
                ></ve-line>

                <div
                  v-if="
                    orderProductLifeCycle == false &&
                    orderTheadData.rows.length == 0
                  "
                  class="noData"
                >
                  {{ $t("text.noData") }}
                </div>
              </panel>
            </div>
            <div v-if="Permit.extendModels().includes('rms')">
              <panel title="租赁月份折线图" class="mgb10">
                <div
                  v-if="rentProductLifeCycle == true"
                  class="noData"
                  style="height: 50px; line-height: 50px"
                >
                  <i class="el-icon-loading"></i>
                </div>
                <ve-line
                  :data="rentTheadData"
                  v-if="
                    rentProductLifeCycle == false &&
                    rentTheadData.rows.length !== 0
                  "
                  :extend="extend"
                ></ve-line>
                <div
                  v-if="
                    rentProductLifeCycle == false &&
                    rentTheadData.rows.length == 0
                  "
                  class="noData"
                  style="height: 50px; line-height: 50px"
                >
                  {{ $t("text.noData") }}
                </div>
              </panel>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="
          activeName == 'detail' &&
          Permit.canActions('productVerify') &&
          product.verifyAt == null
        "
        type="primary"
        size="small"
        :loading="verifyDoing"
        @click="verify"
        >{{ $t("action.verify") }}</el-button
      >
      <el-dropdown
        v-if="
          activeName == 'detail' &&
          Permit.canActions('productManage') &&
          product.images != null
        "
        class="mgl10 mgr10"
        @command="asyncImageToOrder"
      >
        <el-button type="default" size="small" :loading="asyncImageDoing">
          {{ $t("action.asyncImageToOrder") }}
          <i class="el-icon-caret-bottom el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="true">只同步没有图片的</el-dropdown-item>
          <el-dropdown-item command="false">原来有图片的覆盖</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-button
        v-if="
          activeName == 'detail' &&
          Permit.canActions('productManage') &&
          product.images !== null
        "
        type="defalut"
        size="small"
        :loading="asyncImageToInvDoing"
        @click="asyncImageToInv"
        >{{ $t("action.asyncImageToInv") }}</el-button
      >

      <el-button
        v-if="activeName == 'detail' && Permit.canActions('productManage')"
        type="success"
        size="small"
        @click="copy"
        >{{ $t("action.copy") }}</el-button
      >

      <el-button
        v-if="
          activeName == 'sizeTemplate' && Permit.canActions('productManage')
        "
        type="success"
        size="small"
        @click="addSizeTemplates"
      >
        + {{ $t("product.sizeTemplates") }}
      </el-button>
      <el-button
        v-if="activeName == 'supplier' && Permit.canActions('productManage')"
        type="success"
        size="small"
        @click="addSupplier"
      >
        + {{ $t("menu.suppliers") }}
      </el-button>
      <el-button
        v-if="
          activeName == 'quotation' &&
          Permit.canActions('quoteToCustomerManage')
        "
        type="success"
        size="small"
        @click="addQuotation"
      >
        + {{ $t("action.share") }}
      </el-button>
    </div>
    <!-- 版库 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.sizeTemplates')])"
      :close-on-click-modal="false"
      :visible.sync="addSizeTemplateDF"
      width="30%"
    >
      <el-form ref="addSizeTemplateForm" :model="addSizeTemplateObj">
        <div v-for="(item, index) in addSizeTemplateObj.items" :key="index">
          <el-row :gutter="5">
            <el-col :span="8">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="item.size"
                  clearable
                  filterable
                  :placeholder="
                    $t('rules.mustFillSimple', [$t('product.size')])
                  "
                  @change="existJudgeSizeTemplate(index)"
                >
                  <el-option
                    v-for="size in addSizeTemplatesSizes"
                    :key="size"
                    :label="size"
                    :value="size"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <attachment v-model="item.template" class="pt10" />
              </el-form-item>
            </el-col>
            <el-col v-if="item._localRepeat" :span="6">
              <el-form-item>
                <small class="red">{{
                  $t("rules.exist", [$t("product.size")])
                }}</small>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="removeSizeTemplate(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row :gutter="10">
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMoreSizeTemplate"
                >{{ $t("text.create") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addSizeTemplateDoing"
          size="small"
          @click="addSizeTemplateSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addSizeTemplateDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑供应商报价 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('product.supplierPrice')])"
      :visible.sync="editProductSupplierDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="editProductSupplierObjForm"
        :model="editProductSupplierObj"
        label-width="96px"
      >
        <el-form-item
          :prop="'price'"
          :label="$t('product.supplierPrice')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('product.supplierPrice')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editProductSupplierObj.price" />
        </el-form-item>
        <el-form-item
          :prop="'productNo'"
          :label="$t('product.supplierProductNo')"
        >
          <el-input
            size="small"
            v-model.trim="editProductSupplierObj.productNo"
          />
        </el-form-item>
        <div v-if="editProductSupplierObj.supplierSizePrices.length != 0">
          <el-form-item
            :prop="'productNo'"
            :label="$t('product.supplierSizePrice')"
          >
            <el-row class="mgb5">
              <el-col
                v-for="(
                  supplierSizePrice, index
                ) in editProductSupplierObj.supplierSizePrices"
                :key="index"
                :span="12"
              >
                <el-input size="small" v-model.trim="supplierSizePrice.price">
                  <template slot="prepend">
                    <div>
                      <raw-html-limit-number
                        :content="supplierSizePrice.size"
                        :number="6"
                      />
                    </div>
                  </template>
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editProductSupplierSubmitDoing"
          size="small"
          @click="editProductSupplierSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editProductSupplierDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增产品供应商 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.supplierPrice')])"
      :close-on-click-modal="false"
      :visible.sync="addProductSupplierDF"
      width="50%"
    >
      <el-form ref="addSupplierForm" :model="addSupplierObj">
        <div v-for="(item, index) in addSupplierObj.items" :key="index">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="item.supplierId"
                  clearable
                  filterable
                  :placeholder="
                    $t('rules.mustFillSimple', [$t('menu.suppliers')])
                  "
                  @change="existJudgeProductSupplier(index)"
                >
                  <el-option
                    v-for="supplier in addProductSupplierSuppliers"
                    :key="supplier.id"
                    :label="supplier.name"
                    :value="supplier.id"
                  />
                </el-select>
                <small v-if="item._localRepeat" class="red">{{
                  $t("rules.filledIn", [$t("menu.suppliers")])
                }}</small>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.price"
                  :placeholder="
                    $t('rules.mustFillSimple', [$t('product.supplierPrice')])
                  "
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.productNo"
                  :placeholder="$t('product.supplierProductNo')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <small
                  v-if="!item._sizesPriceDF"
                  class="blue"
                  @click="showPriceSizesSupplier(index)"
                  >{{ $t("product.sizePrice") }}</small
                >
                <small
                  v-if="item._sizesPriceDF && item._priceSizes.length == 0"
                  class="orange"
                  >{{ $t("prompt.noProductSize") }}</small
                >
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="removeSupplier(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div
            v-if="item._sizesPriceDF && item._priceSizes.length != 0"
            class="mgb15"
          >
            <el-row :gutter="10" class="mgb5">
              <el-col
                v-for="priceSize in item._priceSizes"
                :key="priceSize.size"
                :span="6"
                class="mb10"
              >
                <el-input size="small" v-model.trim="priceSize.price">
                  <template slot="prepend">
                    <div>
                      <raw-html-limit-number
                        :content="priceSize.size"
                        :number="6"
                      />
                    </div>
                  </template>
                </el-input>
              </el-col>
              <el-col :span="24">
                <small v-if="item._priceSizes.length == 0" class="orange">{{
                  $t("prompt.noProductSize")
                }}</small>
              </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMoreSupplier"
                >{{ $t("text.create") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addSupplierSubmitDoing"
          size="small"
          @click="addSupplierSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addProductSupplierDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑报价 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('action.share')])"
      :close-on-click-modal="false"
      :visible.sync="editProductQuotationDF"
      width="30%"
    >
      <el-form
        ref="editProductQuotationObjForm"
        :model="editProductQuotationObj"
        label-width="70px"
      >
        <el-form-item
          :label="$t('quotation.price')"
          :prop="'price'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('quotation.price')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editProductQuotationObj.price" />
        </el-form-item>
        <el-form-item
          v-if="Permit.extendModels().includes('wms')"
          :label="$t('quotation.hasInv')"
          :prop="'hasInv'"
        >
          <el-checkbox size="small" v-model="editProductQuotationObj.hasInv" />
        </el-form-item>
        <div v-if="editProductQuotationObj.quotationSizePrices.length != 0">
          <el-form-item :prop="'productNo'" :label="$t('quotation.sizePrice')">
            <el-row>
              <el-col
                v-for="(
                  quotationSizePrice, index
                ) in editProductQuotationObj.quotationSizePrices"
                :key="index"
                :span="12"
              >
                <el-input size="small" v-model.trim="quotationSizePrice.price">
                  <template slot="prepend">
                    <div>
                      <raw-html-limit-number
                        :content="quotationSizePrice.size"
                        :number="6"
                      />
                    </div>
                  </template>
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editProductQuotationDoing"
          size="small"
          @click="editProductQuotationSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editProductQuotationDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 报价 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.share')"
      :close-on-click-modal="false"
      :visible.sync="addProductQuotation"
      width="40%"
    >
      <div class="orange font10 mgb15">
        {{ $t("prompt.quotationExplainCustomer") }}
      </div>
      <el-form ref="addProductQuotationObjForm" :model="addProductQuotationObj">
        <div v-for="(item, index) in addProductQuotationObj.items" :key="index">
          <el-row :gutter="10">
            <el-col :span="9">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="item.customerId"
                  filterable
                  clearable
                  remote
                  :placeholder="$t('menu.customers')"
                  :remote-method="querySearchCustomer"
                  :loading="customerLoading"
                  @change="handleSelectCustomer(index)"
                >
                  <el-option
                    v-for="customer in customers"
                    :key="customer.id"
                    :label="customer.text"
                    :value="customer.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.price"
                  :placeholder="
                    $t('rules.mustFillSimple', [$t('quotation.price')])
                  "
                />
              </el-form-item>
            </el-col>
            <el-col v-if="Permit.extendModels().includes('wms')" :span="4">
              <el-form-item>
                <el-checkbox size="small" v-model="item.hasInv">{{
                  $t("quotation.hasInv")
                }}</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <small
                  v-if="!item._sizesPriceDF"
                  class="blue"
                  @click="showPriceSizesQuotation(index)"
                  >{{ $t("product.sizePrice") }}</small
                >
                <small
                  v-if="
                    item._sizesPriceDF && item._quotationSizePrices.length == 0
                  "
                  class="orange"
                  >{{ $t("prompt.noProductSize") }}</small
                >
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="removeQuotation(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col v-if="item._localRepeat || item._invExist" :span="6">
              <small v-if="item._localRepeat" class="red">{{
                $t("rules.filledIn", [$t("menu.customers")])
              }}</small>
              <small v-if="item._invExist" class="red">{{
                $t("rules.shared", [$t("menu.customers")])
              }}</small>
            </el-col>
          </el-row>
          <div
            v-if="item._sizesPriceDF && item._quotationSizePrices.length != 0"
            class="mgb15"
          >
            <el-row :gutter="10">
              <el-col
                v-for="priceSize in item._quotationSizePrices"
                :key="priceSize.size"
                :span="6"
                class="mb10"
              >
                <el-input size="small" v-model.trim="priceSize.price">
                  <template slot="prepend">
                    <div>
                      <raw-html-limit-number
                        :content="priceSize.size"
                        :number="6"
                      />
                    </div>
                  </template>
                </el-input>
              </el-col>
              <el-col :span="24">
                <small
                  v-if="item._quotationSizePrices.length == 0"
                  class="orange"
                  >{{ $t("prompt.noProductSize") }}</small
                >
              </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMoreQuotation"
                >{{ $t("text.create") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addProductQuotationSubmitDoing"
          size="small"
          @click="addProductQuotationSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addProductQuotation = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 同步价格到其他产品 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.synSupplierPrice')"
      :close-on-click-modal="false"
      :visible.sync="synSupplierPriceDF"
      width="50%"
    >
      <div class="mgb15">
        <div class="mgb10">
          <el-checkbox v-model="checkedSupplierPriceDF">
            基准价
            <span class="font12 grey-shallow">
              ({{ rowSupplier.price | currency }})
            </span>
          </el-checkbox>
        </div>
        <div v-if="rowSupplier.supplierSizePrices.length != 0">
          <el-checkbox
            :indeterminate="isIndeterminateSupplierSizesPrice"
            v-model="checkAllSupplierSizesPriceDF"
            @change="handleCheckAllSupplierSizesPrice"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="checkedSupplierSizesPrice"
            @change="handleCheckedSupplierSizesPrice"
          >
            <el-checkbox
              v-for="sizePrice of rowSupplier.supplierSizePrices"
              :key="sizePrice.size"
              :label="sizePrice"
            >
              {{ sizePrice.size }}
              <span class="font12 grey-shallow">
                ({{ sizePrice.price | currency }})
              </span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div>
        <span>同步到同供应商产品</span>
        <span class="float-right">
          <el-checkbox v-model="checkedSearchAllDF">
            <span class="font12 grey">所有查询出来的产品</span>
          </el-checkbox>
        </span>
      </div>
      <div>
        <div
          class="search with-narrows"
          style="padding-left: 0px; padding-bottom: 5px"
        >
          <el-form
            :inline="true"
            @submit.native.prevent="search"
            :model="searchProductForm"
            size="small"
          >
            <el-form-item>
              <el-select
                size="small"
                v-model="searchProductForm.supplierId"
                filterable
                clearable
                :placeholder="$t('menu.suppliers')"
              >
                <el-option
                  v-for="supplier in suppliers"
                  :key="supplier.id"
                  :label="supplier.name"
                  :value="supplier.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                size="small"
                v-model="searchProductForm.categoryId"
                filterable
                clearable
                :placeholder="$t('menu.categories')"
              >
                <el-option
                  v-for="category in categories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model.trim="searchProductForm.productNo"
                :placeholder="$t('product.productNo')"
                size="small"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                native-type="submit"
              />
            </el-form-item>
          </el-form>
        </div>
        <div>
          <vxe-table
            :data="synProducts"
            @checkbox-change="setSelectedSynSupplierPrice"
            @checkbox-all="setSelectedSynSupplierPrice"
            :custom-config="{ storage: true }"
            :loading="loading"
            id="stockInsTable"
            row-id="id"
            ref="recordsTableSynProducts"
            class="recordsTable"
            size="mini"
            resizable
            round
            auto-resize
            highlight-hover-row
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column field="checkbox" type="checkbox" width="35" />
            <vxe-table-column
              field="images"
              :title="$t('product.images')"
              width="80"
            >
              <template v-slot="{ row }">
                <thumbnail :images="row.images" />
              </template>
            </vxe-table-column>

            <vxe-table-column
              field="productNo"
              :title="$t('product.productNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <span v-if="row.verifyAt != null" class="green font10"
                  >({{ $t("product.verify") }})</span
                >
                {{ row.productNo }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="categoryName"
              :title="$t('product.category')"
              width="80"
            />
            <vxe-table-column
              v-if="Permit.canActions('globalSalePrice')"
              field="salesPrice"
              :title="$t('product.salesPrice')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.salesPrice | currency }}</template
              >
            </vxe-table-column>
            <vxe-table-column
              field="color"
              :title="$t('product.color')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <span class="font10">{{ row.colors.join(",") }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="size"
              :title="$t('product.size')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <span class="font10">{{ row.sizes.join(",") }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
          <div class="flex flex-between pager">
            <div class="selected-qty-tips">
              选中了
              <span class="strong">{{ synSupplierPriceSelectRecordQty }}</span>
              条记录
            </div>
            <div>
              <vxe-pager
                size="small"
                :loading="false"
                :background="false"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.total"
                :layouts="pagerConfig.layouts"
                :page-sizes="pagerConfig.pageSizes"
                @page-change="changePager"
              ></vxe-pager>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="synProductsSubmitDoing"
          size="small"
          @click="synProductsSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="synSupplierPriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 制作工艺-->
    <el-dialog
      :append-to-body="true"
      :title="$t('product.craftwork')"
      :close-on-click-modal="false"
      :visible.sync="updateCraftworkDF"
      width="50%"
    >
      <el-form ref="updateCraftworkObjForm" :model="updateCraftworkObj">
        <fieldset>
          <tinymce-editor
            ref="editor"
            v-model="updateCraftworkObj.craftwork"
            :height="150"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="updateCraftworkSubmitDoing"
          size="small"
          @click="updateCraftworkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="updateCraftworkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 产品复制 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.copy')"
      :close-on-click-modal="false"
      :visible.sync="copyDF"
      width="30%"
    >
      <el-form ref="copyObjForm" :model="copyObj" label-width="60px">
        <el-form-item
          :label="$t('product.productNo')"
          :prop="'productNo'"
          :rules="[
            {
              required: true,
              validator: validateProductNo,
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="copyObj.productNo" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="copySubmitDoing"
          size="small"
          @click="copySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="copyDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 同步生产价 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.synMes')"
      :close-on-click-modal="false"
      :visible.sync="synMesDF"
      width="30%"
    >
      <el-form ref="synMesObjForm" :model="synMesObj" label-width="70px">
        <el-form-item
          :label="$t('text.date')"
          :prop="'_date'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.date')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="synMesObj._date"
            range-separator="-"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
            type="daterange"
            size="small"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item :label="$t('text.type')" :prop="'type'">
          <el-radio-group v-model="synMesObj.type" size="small">
            <el-radio label="all">{{ $t("sysMesTypes.all") }}</el-radio>
            <el-radio label="onlyZero">{{
              $t("sysMesTypes.onlyZero")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="synMesSubmitDoing"
          size="small"
          @click="synMesSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="synMesDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import TinymceEditor from "@/components/TinymceEditor";
import VeLine from "v-charts/lib/line.common";
import { page, table } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtml from "@/components/RawHtml";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Attachment from "@/components/Attachment";
import Currency from "@/components/Currency";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";
import ProductSizeTemplate from "@/api/productSizeTemplate.js";
import Supplier from "@/api/supplier.js";
import Quotation from "@/api/quotation.js";
import Customer from "@/api/customer.js";
import Category from "@/api/category.js";
import ShowMaterial from "./showMaterial";
import ShowPhase from "./showPhase";
import Order from "@/api/order.js";
import RentItem from "@/api/rentItem.js";

function buildSizeTemplate() {
  return {
    productId: null,
    size: null,
    template: null,
    tenantId: null,
    _localRepeat: false,
  };
}
function buildProductSupplier() {
  return {
    supplierId: null,
    price: null,
    defaultSupplier: false,
    productNo: null,
    productId: null,
    supplierSizePrices: [],
    _localRepeat: false,
    _priceSizes: [],
    _sizesPriceDF: false,
  };
}

function buildProductQuotation() {
  return {
    productId: null,
    price: null,
    hasInv: false,
    product: null,
    inquirierId: null,
    quoterId: null,
    quoterName: null,
    customerId: null,
    customerName: null,
    quotationSizePrices: [],
    _quotationSizePrices: [],
    _localRepeat: false,
    _invExist: false,
    _sizesPriceDF: false,
  };
}

export default {
  props: {
    uuid: String,
  },
  mixins: [page, table.pager, table.search, table.checker],
  components: {
    Thumbnail,
    RawHtml,
    RawHtmlLimitNumber,
    Attachment,
    ShowMaterial,
    ShowPhase,
    TinymceEditor,
    VeLine,
    Currency,
  },
  data() {
    var validateProductNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("product.productNo")]))
        );
        return;
      }
      Product.findByProductNo({ productNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("product.productNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      activeName: "detail",
      product: { uuid: null },
      mmsCost: null,
      mesCost: [],
      productSizeTemplates: [],
      productSuppliers: [],
      productQuotations: [],
      productQuotationsSearch: [],
      // 添加版库
      addSizeTemplateDF: false,
      addSizeTemplatesSizes: [],
      addSizeTemplateObj: {
        items: [],
      },
      addSizeTemplateDoing: false,
      // 编辑供应商
      editProductSupplierDF: false,
      row: null,
      editProductSupplierObj: {
        price: null,
        productNo: null,
        supplierSizePrices: [],
      },
      editProductSupplierSubmitDoing: false,
      // 新增供应商
      addProductSupplierDF: false,
      suppliers: [],
      addProductSupplierSuppliers: [],
      addSupplierObj: {
        items: [],
      },
      addSupplierSubmitDoing: false,
      // 编辑报价
      editProductQuotationDF: false,
      editProductQuotationObj: {
        price: null,
        hasInv: false,
        quotationSizePrices: [],
      },
      editProductQuotationDoing: false,
      //
      quotationSearchCustomName: null,
      // 新增报价
      addProductQuotation: false,
      customerLoading: false,
      addProductQuotationObj: {
        items: [],
      },
      addProductQuotationSubmitDoing: false,
      customers: [],
      customersTotal: null,
      //
      verifyDoing: false,
      asyncImageDoing: false,
      // 同步价格到其他产品
      synSupplierPriceDF: false,
      checkedSupplierPriceDF: false,
      checkedSupplierSizesPrice: [],
      isIndeterminateSupplierSizesPrice: true,
      checkAllSupplierSizesPriceDF: false,
      rowSupplier: { price: null, supplierSizePrices: [] },
      checkedSearchAllDF: false,
      searchProductForm: {
        supplierId: null,
        categoryId: null,
        productNo: null,
      },
      categories: [],
      synProducts: [],
      synProductsSubmitDoing: false,
      synSupplierPriceSelectRecords: [],
      synSupplierPriceSelectRecordQty: 0,
      //
      asyncImageToInvDoing: false,
      // 编辑制作工艺
      updateCraftworkDF: false,
      updateCraftworkObj: {
        craftwork: null,
        uuid: null,
      },
      updateCraftworkSubmitDoing: false,
      // 复制
      validateProductNo: validateProductNo,
      copyDF: false,
      copyObj: {
        productNo: null,
      },
      copySubmitDoing: false,
      //
      orderTheadData: {
        columns: ["日期", "单量"],
        rows: [],
      },
      rentTheadData: {
        columns: ["日期", "单量"],
        rows: [],
      },
      orderProductLifeCycle: false,
      rentProductLifeCycle: false,
      extend: {
        series: {
          smooth: false,
        },
      },
      //====
      synMesDF: false,
      synMesObj: {
        _date: null,
        createAtStartAt: null,
        createAtEndAt: null,
        type: "onlyZero",
      },
      synMesSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    synMes() {
      const self = this;
      self.synMesObj._date = null;
      self.synMesObj.createAtStartAt = null;
      self.synMesObj.createAtEndAt = null;
      self.synMesObj.type = "onlyZero";
      self.synMesSubmitDoing = false;
      self.synMesDF = true;
    },
    synMesSubmit() {
      const self = this;
      this.$refs.synMesObjForm.validate((valid) => {
        if (valid) {
          self.synMesObj.createAtStartAt = Util.formatDateTime(
            self.synMesObj._date[0]
          );
          self.synMesObj.createAtEndAt = Util.formatDateTime(
            self.synMesObj._date[1]
          );
          self.synMesSubmitDoing = true;
          Product.syncCostPriceToMes(self.product.id, self.synMesObj).then(
            function (res) {
              self.synMesSubmitDoing = false;
              self.synMesDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.asyncSuccess"),
                  type: "success",
                });
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    //产品复制
    copy() {
      const self = this;
      self.copyObj.productNo = self.product.productNo + "Copy";
      self.copySubmitDoing = false;
      self.copyDF = true;
    },
    copySubmit() {
      const self = this;
      this.$refs.copyObjForm.validate((valid) => {
        if (valid) {
          self.copySubmitDoing = true;
          Product.copy(self.product.id, self.copyObj).then(function (res) {
            self.copySubmitDoing = false;
            self.copyDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.copySuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //
    updataCraftwork() {
      const self = this;
      self.updateCraftworkObj.uuid = self.product.uuid;
      self.updateCraftworkObj.craftwork = self.product.craftwork;
      self.updateCraftworkSubmitDoing = false;
      self.updateCraftworkDF = true;
    },
    updateCraftworkSubmit() {
      const self = this;
      this.$refs.updateCraftworkObjForm.validate((valid) => {
        if (valid) {
          self.updateCraftworkSubmitDoing = true;
          Product.updateCraftwork(
            self.product.id,
            self.updateCraftworkObj
          ).then(function (res) {
            self.updateCraftworkSubmitDoing = false;
            self.updateCraftworkDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.product.craftwork = self.updateCraftworkObj.craftwork;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //
    asyncImageToInv() {
      const self = this;
      self.asyncImageToInvDoing = true;
      Product.asyncImageToInv(self.product.id).then(function (res) {
        self.asyncImageToInvDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.asyncSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },

    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getProduct();
      }
      if (this.activeName == "sizeTemplate") {
        this.getProductSizeTemplates();
      }
      if (this.activeName == "supplier") {
        this.getProductSuppliers();
      }
      if (this.activeName == "quotation") {
        this.getProductQuotations();
      }
      if (this.activeName == "lifeCycle") {
        if (this.Permit.extendModels().includes("oms")) {
          this.getOrderProductLifeCycle();
        }
        if (this.Permit.extendModels().includes("rms")) {
          this.getRentProductLifeCycle();
        }
      }
    },
    getOrderProductLifeCycle() {
      const self = this;
      self.orderProductLifeCycle = true;
      Order.productLifeCycle({ productNo: self.product.productNo }).then(
        function (res) {
          if (res.status == 200) {
            self.orderTheadData.rows = res.data.map((r) => {
              return {
                日期: r.month,
                单量: r.productQty,
              };
            });
            self.orderProductLifeCycle = false;
            // console.log("====order", self.orderTheadData.rows);
          } else {
            self.sysError();
          }
        }
      );
    },
    getRentProductLifeCycle() {
      const self = this;
      self.rentProductLifeCycle = true;
      RentItem.productLifeCycle({ productNo: self.product.productNo }).then(
        function (res) {
          if (res.status == 200) {
            self.rentTheadData.rows = res.data.map((r) => {
              return {
                日期: r.month,
                单量: r.productQty,
              };
            });
            self.rentProductLifeCycle = false;
            // console.log("====rent", self.rentTheadData.rows);
          } else {
            self.sysError();
          }
        }
      );
    },
    getProduct() {
      const self = this;
      self.loadingStart();
      Product.findByUuid({ uuid: self.uuid }).then(function (res) {
        if (res.data.code === 200) {
          self.product = res.data.entity;
          if (
            self.Permit.extendModels().includes("mms") &&
            self.Permit.canActions("globalCostPrice")
          ) {
            self.getMmsCost(self.product.id);
          }
          if (
            self.Permit.extendModels().includes("mes") &&
            self.Permit.canActions("globalCostPrice")
          ) {
            self.getMesCost(self.product.id);
          }
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getMmsCost(id) {
      const self = this;
      Product.calcCostMms(id).then(function (res) {
        if (res.status === 200) {
          self.mmsCost = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getMesCost(id) {
      const self = this;
      Product.calcCostMes(id).then(function (res) {
        if (res.status === 200) {
          self.mesCost = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 同步图片至订单
    asyncImageToOrder(item) {
      const self = this;
      self.asyncImageDoing = true;
      Product.asyncImageToOrder(self.product.id, { onlyNull: item }).then(
        function (res) {
          self.asyncImageDoing = false;
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.asyncSuccess"),
              type: "success",
            });
          } else {
            self.sysError();
          }
        }
      );
    },
    //
    verify() {
      const self = this;
      self.verifyDoing = true;
      Product.verifyBatch([self.product.id]).then(function (res) {
        self.verifyDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.$emit("updateInfo");
        } else {
          self.sysError();
        }
      });
    },
    // -----------
    // 新增报价
    addQuotation() {
      const self = this;
      const newBuildProductQuotation = buildProductQuotation();
      newBuildProductQuotation._quotationSizePrices = self.product.sizes.map(
        (s) => {
          return { size: s, price: null };
        }
      );
      self.addProductQuotationObj.items = [
        JSON.parse(JSON.stringify(newBuildProductQuotation)),
        JSON.parse(JSON.stringify(newBuildProductQuotation)),
        JSON.parse(JSON.stringify(newBuildProductQuotation)),
      ];
      self.addProductQuotationSubmitDoing = false;
      self.addProductQuotation = true;
    },
    querySearchCustomer(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.customerLoading = true;
      Customer.vagueFindByName({ name: queryString }).then(function (res) {
        self.customers = res.data.filter((d) => d.type == "wholesale");
        for (const customer of self.customers) {
          if (customer.sourceTenantId == null) {
            Vue.set(customer, "text", customer.name);
          } else {
            Vue.set(customer, "text", customer.name + "(简赢)");
          }
        }
        self.customerLoading = false;
      });
    },
    handleSelectCustomer(idx) {
      const self = this;
      // console.log("==", self.addProductQuotationObj.items);
      self.addProductQuotationObj.items[idx]._localRepeat = false;
      self.addProductQuotationObj.items[idx]._invExist = false;
      const item = self.customers.find(
        (p) => p.id === self.addProductQuotationObj.items[idx].customerId
      );
      // 库存过滤
      if (
        self.productQuotations.filter(
          (q) =>
            q.customerId == self.addProductQuotationObj.items[idx].customerId
        ).length != 0
      ) {
        self.addProductQuotationObj.items[idx]._invExist = true;
        return;
      }
      // 本地过滤
      const iis = self.addProductQuotationObj.items.filter(
        (s) => s.customerId === item.id
      );
      if (iis.length > 1) {
        self.addProductQuotationObj.items[idx]._localRepeat = true;
        return;
      }
      self.addProductQuotationObj.items[idx].inquirierId = item.sourceTenantId;
      self.addProductQuotationObj.items[idx].customerId = item.id;
      self.addProductQuotationObj.items[idx].customerName = item.name;
      self.addProductQuotationObj.items[idx].quoterId =
        self.Permit.currentTenant().id;
      self.addProductQuotationObj.items[idx].quoterName =
        self.Permit.currentUser().id;
      self.addProductQuotationObj.items[idx].productId = self.product.id;
      self.addProductQuotationObj.items[idx].product = self.product;
    },
    removeQuotation(idx) {
      this.addProductQuotationObj.items.splice(idx, 1);
    },
    addMoreQuotation() {
      const self = this;
      const newBuildProductQuotation = buildProductQuotation();
      newBuildProductQuotation._quotationSizePrices = self.product.sizes.map(
        (s) => {
          return { size: s, price: null };
        }
      );
      this.addProductQuotationObj.items.push(newBuildProductQuotation);
    },
    showPriceSizesQuotation(idx) {
      this.addProductQuotationObj.items[idx]._sizesPriceDF = true;
    },
    addProductQuotationSubmit() {
      const self = this;
      const items = this.addProductQuotationObj.items.filter(function (item) {
        return item.customerId != null && item.price != null;
      });
      if (items.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }
      const errDatas = items.filter(
        (s) => s._localRepeat === true || s._invExist === true
      );
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      for (const i of items) {
        if (!Util.regexPrice(i.price) && i.price !== 0) {
          self.$message({
            message: self.$t("rules.regex", [self.$t("quotation.price")]),
            type: "warning",
          });
          return;
        }
        const quotationSizePrices = i._quotationSizePrices.filter(
          (p) => p.price != null && p.price !== ""
        );
        if (quotationSizePrices.length !== 0) {
          for (const f of quotationSizePrices) {
            if (!Util.regexPrice(f.price) && f.price !== 0) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("product.sizePrice")]),
                type: "warning",
              });
              return;
            }
          }
        }
        i.quotationSizePrices = quotationSizePrices;
      }
      self.addProductQuotationSubmitDoing = true;
      Quotation.insertBatch(items).then(function (res) {
        self.addProductQuotationSubmitDoing = false;
        self.addProductQuotation = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.quotationSuccess"),
            type: "success",
          });
          self.getProductQuotations();
        } else {
          self.sysError();
        }
      });
    },
    //
    searchProductQuotation() {
      const self = this;
      // console.log("===", self.quotationSearchCustomName);
      if (
        self.quotationSearchCustomName != null &&
        self.quotationSearchCustomName !== ""
      ) {
        self.productQuotationsSearch = self.productQuotations.filter(
          (pq) => pq.customerName.indexOf(self.quotationSearchCustomName) != -1
        );
      } else {
        self.getProductQuotations();
      }
    },
    // 编辑报价
    editProductQuotation(row) {
      const self = this;
      self.row = row;
      self.editProductQuotationObj.price = row.price;
      self.editProductQuotationObj.hasInv = row.hasInv;
      if (self.product.sizes.length !== 0) {
        self.editProductQuotationObj.quotationSizePrices =
          self.product.sizes.map((s) => {
            return {
              size: s,
              price:
                row.quotationSizePrices.find((sp) => sp.size === s) != null
                  ? row.quotationSizePrices.find((sp) => sp.size === s).price
                  : null,
            };
          });
      } else {
        self.editProductQuotationObj.quotationSizePrices = [];
      }
      self.editProductQuotationDoing = false;
      self.editProductQuotationDF = true;
    },
    editProductQuotationSubmit() {
      const self = this;
      self.$refs.editProductQuotationObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexPrice(self.editProductQuotationObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("quotation.price")]),
              type: "warning",
            });
            return;
          }
          if (self.editProductQuotationObj.quotationSizePrices.length !== 0) {
            const quotationSizePricesFilter =
              self.editProductQuotationObj.quotationSizePrices.filter(
                (p) => p.price != null && p.price !== ""
              );
            if (quotationSizePricesFilter.length !== 0) {
              for (const f of quotationSizePricesFilter) {
                if (!Util.regexPrice(f.price)) {
                  self.$message({
                    message: self.$t("rules.regex", [
                      self.$t("quotation.sizePrice"),
                    ]),
                    type: "warning",
                  });
                  return;
                }
              }
            }
            self.editProductQuotationObj.quotationSizePrices =
              quotationSizePricesFilter;
          }
          self.editProductQuotationDoing = true;
          Quotation.update(self.row.id, self.editProductQuotationObj).then(
            function (res) {
              self.editProductQuotationDoing = false;
              self.editProductQuotationDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.getProductQuotations();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 删除报价
    deleteProductQuotation(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Quotation.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getProductQuotations();
          } else {
            self.sysError();
          }
        });
      }
    },
    // -----------
    // 同步价格到其他产品

    setSelectedSynSupplierPrice() {
      this.setSelectedQtySynSupplierPrice();
      this.synSupplierPriceSelectRecords =
        (this.$refs.recordsTableSynProducts &&
          this.$refs.recordsTableSynProducts.getCheckboxRecords()) ||
        [];
    },
    setSelectedQtySynSupplierPrice() {
      this.synSupplierPriceSelectRecordQty =
        this.$refs.recordsTableSynProducts &&
        this.$refs.recordsTableSynProducts.getCheckboxRecords().length;
    },
    synSupplierPrice(row) {
      const self = this;
      self.rowSupplier = row;
      self.getSuppliers();
      self.getCategories();
      self.checkedSupplierPriceDF = false;
      self.checkedSupplierSizesPrice = [];
      self.synProducts = [];
      self.synSupplierPriceSelectRecords = [];
      self.synSupplierPriceDF = true;
    },
    getSuppliers() {
      const self = this;
      Supplier.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getCategories() {
      const self = this;
      Category.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.categories = res.data;
        } else {
          self.sysError();
        }
      });
    },
    handleCheckAllSupplierSizesPrice(val) {
      this.checkedSupplierSizesPrice = val
        ? this.rowSupplier.supplierSizePrices
        : [];
      this.isIndeterminateSupplierSizesPrice = false;
    },
    handleCheckedSupplierSizesPrice(value) {
      let checkedCount = value.length;
      this.checkAllSupplierSizesPriceDF =
        checkedCount === this.rowSupplier.supplierSizePrices.length;
      this.isIndeterminateSupplierSizesPrice =
        checkedCount > 0 &&
        checkedCount < this.rowSupplier.supplierSizePrices.length;
    },

    search() {
      this.searchProduct();
    },
    changePager(params) {
      this.pager.currentPage = params.currentPage;
      this.pager.pageSize = params.pageSize;
      this.searchProduct();
    },
    combineParams() {
      let params = {};
      if (this.pager) {
        params.currentPage = this.pager.currentPage;
        params.pageSize = this.pager.pageSize;
      }
      if (this.searchProductForm) {
        for (let key in this.searchProductForm) {
          if (this.searchProductForm[key]) {
            params[key] = this.searchProductForm[key];
          }
        }
      }
      return params;
    },
    searchProduct() {
      const self = this;
      self.synProducts = [];
      if (
        JSON.stringify(Util.deleteObjValueIsNull(self.searchProductForm)) ==
        "{}"
      ) {
        self.$message({
          message: "至少选择一个筛选条件",
          type: "warning",
        });
        return;
      }
      Product.search(self.combineParams()).then(function (res) {
        self.synProducts = res.data.records;
        self.pager.total = res.data.total;
      });
    },
    synProductsSubmit() {
      const self = this;
      if (
        !self.checkedSupplierPriceDF &&
        self.checkedSupplierSizesPrice.length == 0
      ) {
        self.$message({
          message: "至少选择一个价格",
          type: "warning",
        });
        return;
      }
      if (
        !self.checkedSearchAllDF &&
        self.synSupplierPriceSelectRecords.length == 0
      ) {
        self.$message({
          message: "至少选择一个需要同步的产品",
          type: "warning",
        });
        return;
      }
      let obj = {
        productSupplierId: self.rowSupplier.id,
        asyncPrice: self.checkedSupplierPriceDF,
        asyncSizes: self.checkedSupplierSizesPrice.map((c) => c.size),
        searchProduct: null,
      };
      if (self.checkedSearchAllDF) {
        if (
          JSON.stringify(Util.deleteObjValueIsNull(self.searchProductForm)) ==
          "{}"
        ) {
          self.$message({
            message: "至少选择一个筛选条件",
            type: "warning",
          });
          return;
        }
        obj.searchProduct = {
          ids: [],
          supplierId: self.searchProductForm.supplierId,
          categoryId: self.searchProductForm.categoryId,
          productNo: self.searchProductForm.productNo,
        };
      } else {
        obj.searchProduct = {
          ids: self.synSupplierPriceSelectRecords.map((c) => c.id),
          supplierId: null,
          categoryId: null,
          productNo: null,
        };
      }
      self.synProductsSubmitDoing = true;
      Product.asyncPriceToOther(self.product.id, obj).then(function (res) {
        self.synProductsSubmitDoing = false;
        self.synSupplierPriceDF = false;
        if (res.status === 200) {
          self.$message({
            message:
              "提交成功，请3分钟后到相应的产品中检查。勾选产品中没有该供应商的将忽略",
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    // 新增产品供应商
    addSupplier() {
      const self = this;
      self.addSupplierSubmitDoing = false;
      Supplier.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
          const productSupplierIds = self.productSuppliers.map(
            (s) => s.supplierId
          );
          self.addProductSupplierSuppliers = self.suppliers.filter(
            (s) => !productSupplierIds.includes(s.id)
          );
          const newBuildProductSupplier = buildProductSupplier();
          newBuildProductSupplier._priceSizes = self.product.sizes.map((s) => {
            return { size: s, price: null };
          });
          self.addSupplierObj.items = [
            JSON.parse(JSON.stringify(newBuildProductSupplier)),
            JSON.parse(JSON.stringify(newBuildProductSupplier)),
            JSON.parse(JSON.stringify(newBuildProductSupplier)),
          ];
          self.addProductSupplierDF = true;
        } else {
          self.sysError();
        }
      });
    },
    removeSupplier(index) {
      this.addSupplierObj.items.splice(index, 1);
    },
    addMoreSupplier() {
      const self = this;
      const newBuildProductSupplier = buildProductSupplier();
      newBuildProductSupplier._priceSizes = self.product.sizes.map((s) => {
        return { size: s, price: null };
      });
      this.addSupplierObj.items.push(newBuildProductSupplier);
    },
    showPriceSizesSupplier(idx) {
      this.addSupplierObj.items[idx]._sizesPriceDF = true;
    },
    existJudgeProductSupplier(idx) {
      const self = this;
      this.addSupplierObj.items[idx]._localRepeat = false;
      if (this.addSupplierObj.items[idx].supplierId != null) {
        // 本地过滤
        const iis = self.addSupplierObj.items.filter(function (s) {
          return s.supplierId === self.addSupplierObj.items[idx].supplierId;
        });
        if (iis.length > 1) {
          this.addSupplierObj.items[idx]._localRepeat = true;
        }
      }
    },
    addSupplierSubmit() {
      const self = this;
      const items = this.addSupplierObj.items.filter(function (item) {
        return item.supplierId != null && item.price != null;
      });
      if (items.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }
      const errDatas = items.filter((s) => s._localRepeat === true);
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      for (const i of items) {
        if (!Util.regexPrice(i.price) && i.price !== 0) {
          self.$message({
            message: self.$t("rules.regex", [self.$t("product.supplierPrice")]),
            type: "warning",
          });
          return;
        }
        const priceSizesFilter = i._priceSizes.filter(
          (p) => p.price != null && p.price !== ""
        );
        if (priceSizesFilter.length !== 0) {
          for (const f of priceSizesFilter) {
            if (!Util.regexPrice(f.price) && f.price !== 0) {
              self.$message({
                message: self.$t("rules.regex", [
                  self.$t("product.supplierSizePrice"),
                ]),
                type: "warning",
              });
              return;
            }
          }
        }

        i.productId = self.product.id;
        i.supplierSizePrices = priceSizesFilter;
      }
      if (self.productSuppliers.length === 0) {
        items[0].defaultSupplier = true;
      }

      self.addSupplierSubmitDoing = true;
      // console.log("====", items);
      Product.createProductSupplier(items).then(function (res) {
        self.addSupplierSubmitDoing = false;
        self.addProductSupplierDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.getProductSuppliers();
        } else {
          self.sysError();
        }
      });
    },

    // 设置默认供应商
    setDefaultSupplier(row) {
      const self = this;
      Product.updateDefaultSupplier(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.getProductSuppliers();
        } else {
          self.sysError();
        }
      });
    },
    // 删除产品供应商
    deleteProductSupplier(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Product.deleteProductSupplier(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getProductSuppliers();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑产品供应商
    editProductSupplier(row) {
      const self = this;
      self.row = row;
      self.editProductSupplierObj.price = row.price;
      self.editProductSupplierObj.productNo = row.productNo;
      if (self.product.sizes.length !== 0) {
        self.editProductSupplierObj.supplierSizePrices = self.product.sizes.map(
          (s) => {
            return {
              size: s,
              price:
                row.supplierSizePrices.find((sp) => sp.size === s) != null
                  ? row.supplierSizePrices.find((sp) => sp.size === s).price
                  : null,
            };
          }
        );
      } else {
        self.editProductSupplierObj.supplierSizePrices = [];
      }
      self.editProductSupplierSubmitDoing = false;
      self.editProductSupplierDF = true;
    },
    editProductSupplierSubmit() {
      const self = this;
      this.$refs.editProductSupplierObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexPrice(self.editProductSupplierObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("product.supplierPrice"),
              ]),
              type: "warning",
            });
            return;
          }
          if (self.editProductSupplierObj.supplierSizePrices.length !== 0) {
            const supplierSizePricesFilter =
              self.editProductSupplierObj.supplierSizePrices.filter(
                (p) => p.price != null && p.price !== ""
              );
            if (supplierSizePricesFilter.length !== 0) {
              for (const f of supplierSizePricesFilter) {
                if (!Util.regexPrice(f.price)) {
                  self.$message({
                    message: self.$t("rules.regex", [
                      self.$t("product.supplierSizePrice"),
                    ]),
                    type: "warning",
                  });
                  return;
                }
              }
            }
            self.editProductSupplierObj.supplierSizePrices =
              supplierSizePricesFilter;
          }

          self.editProductSupplierSubmitDoing = true;
          Product.updateProductSupplier(
            self.row.id,
            self.editProductSupplierObj
          ).then(function (res) {
            self.editProductSupplierSubmitDoing = false;
            self.editProductSupplierDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getProductSuppliers();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // -----------
    //  删除版库
    deleteProductSizeTemplate(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        ProductSizeTemplate.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getProductSizeTemplates();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 添加版库
    addSizeTemplates() {
      const self = this;
      const productSizeTemplatesSizes = self.productSizeTemplates.map(
        (s) => s.size
      );
      self.addSizeTemplatesSizes = self.product.sizes.filter(
        (s) => !productSizeTemplatesSizes.includes(s)
      );
      self.addSizeTemplateObj.items = [
        buildSizeTemplate(),
        buildSizeTemplate(),
        buildSizeTemplate(),
      ];
      self.addSizeTemplateDoing = false;
      self.addSizeTemplateDF = true;
    },
    existJudgeSizeTemplate(idx) {
      const self = this;
      this.addSizeTemplateObj.items[idx]._localRepeat = false;
      // 本地过滤
      const iis = self.addSizeTemplateObj.items.filter(function (s) {
        return s.size === self.addSizeTemplateObj.items[idx].size;
      });
      if (iis.length > 1) {
        this.addSizeTemplateObj.items[idx]._localRepeat = true;
      }
    },
    removeSizeTemplate(index) {
      this.addSizeTemplateObj.items.splice(index, 1);
    },
    addMoreSizeTemplate() {
      this.addSizeTemplateObj.items.push(buildSizeTemplate());
    },
    addSizeTemplateSubmit() {
      const self = this;
      const sizeTemplatesFilter = self.addSizeTemplateObj.items.filter(
        (c) => c.size != null
      );
      if (sizeTemplatesFilter.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneValidData"),
          type: "warning",
        });
        return;
      }
      const errDatas = sizeTemplatesFilter.filter(
        (s) => s._localRepeat === true
      );
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      for (const sizeTemplate of sizeTemplatesFilter) {
        sizeTemplate.productId = self.product.id;
        sizeTemplate.tenantId = self.Permit.currentTenant().id;
      }
      self.addSizeTemplateDoing = true;
      ProductSizeTemplate.insertBatch(sizeTemplatesFilter).then(function (res) {
        self.addSizeTemplateDoing = false;
        self.addSizeTemplateDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.getProductSizeTemplates();
        } else {
          self.sysError();
        }
      });
    },

    getProductSizeTemplates() {
      const self = this;
      ProductSizeTemplate.findByProductId(self.product.id).then(function (res) {
        if (res.status === 200) {
          self.productSizeTemplates = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getProductSuppliers() {
      const self = this;
      Product.productSuppliersfindById(self.product.id).then(function (res) {
        if (res.status === 200) {
          self.productSuppliers = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getProductQuotations() {
      const self = this;
      Quotation.findByProductId(self.product.id).then(function (res) {
        if (res.status === 200) {
          self.productQuotations = res.data;
          self.productQuotationsSearch = res.data;
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>